let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gQfqa")).then(() => parcelRequire('bprG4'));